/**
 * Returns the url when it is safe to put in a link (http(s), a path on this site, mailto:, tel: or
 * an #anchor), otherwise null. Editors type these values, so `javascript:` and `data:` must never pass.
 */
export function getSafeHref(url: string | null | undefined): string | null {
  const trimmed = url?.trim();
  if (!trimmed) return null;
  // `//host` is protocol-relative and would leave the site without being obvious to the editor.
  return /^(https?:\/\/|\/(?!\/)|mailto:|tel:|#)/i.test(trimmed) ? trimmed : null;
}
